export const SNAP_THRESHOLD = 15;
export const ANIMATION_DURATION_MS = 500;
export const ANIMATION_DURATION_MS_CSS = '.5s';